// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__36plk","notes":"Notes_notes__2Y5dn","note":"Notes_note__2MuJR","markdown":"Notes_markdown__1viPW"};